// jshint module: true

// Find parent by classname
export default function findParentByClassName (element, className) {
  while ((element = element.parentElement) && !element.classList.contains(className)) {
    //
  }

  return element;
}



// WEBPACK FOOTER //
// ./website/assets/scripts/modules/find-parent-by-classname.js